import { useSyncExternalStore } from "react";
import type { WaveRealtimeStatus, WaveSaveState } from "@vida/wave-core";
import { waveSaveStateLabel } from "@vida/wave-core";
import {
  getRealtimeStatus,
  getSyncEmitError,
  getWaveSaveState,
  subscribeRealtimeStatus,
  subscribeSyncEmitError,
  subscribeWaveSaveState,
} from "../../services/waveSession";

type Props = {
  presenceError?: string | null;
  networkHydrating?: boolean;
};

function realtimeLabel(status: WaveRealtimeStatus): string {
  switch (status) {
    case "online":
      return "Live";
    case "polling":
      return "Sync";
    default:
      return "Offline";
  }
}

export function WaveSyncStatusStrip({
  presenceError = null,
  networkHydrating = false,
}: Props) {
  const realtimeStatus = useSyncExternalStore(
    subscribeRealtimeStatus,
    getRealtimeStatus,
    () => "offline" as WaveRealtimeStatus,
  );
  const saveState = useSyncExternalStore(
    subscribeWaveSaveState,
    getWaveSaveState,
    () => "synced" as WaveSaveState,
  );
  const syncEmitError = useSyncExternalStore(
    subscribeSyncEmitError,
    getSyncEmitError,
    () => null,
  );

  const footerError = presenceError ?? syncEmitError;

  return (
    <div
      className="wave-sync-status-strip"
      role="status"
      aria-live="polite"
      aria-label="Stato connessione e salvataggio documento"
    >
      <div className="trust-status-badges">
        <div className={`realtime-badge realtime-${realtimeStatus}`}>
          <span className="realtime-dot" aria-hidden />
          <span>{realtimeLabel(realtimeStatus)}</span>
        </div>
        <div className={`save-badge save-${saveState}`}>
          <span className="save-dot" aria-hidden />
          <span>{waveSaveStateLabel(saveState)}</span>
        </div>
        {networkHydrating && (
          <span className="wave-sync-status-hint muted">Caricamento cloud…</span>
        )}
      </div>
      {footerError && (
        <span className="wave-sync-status-error">{footerError}</span>
      )}
    </div>
  );
}
